<template>
  <div id="OrganizationalStructure" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="level">
        <q-list class="buttons-list">
          <q-item
            v-for="item in levelList"
            :key="item.name"
            clickable
            v-ripple
            :active="level === item"
            @click="changeLevelSelecet(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section class="ellipsis">{{ item.name }}</q-item-section>
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in levelList" :key="item.name">
          <q-card-section v-if="level === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.id"
              :params="params"
              :id="item.id"
              :name="item.name"
              :page="page"
              clean-layout
              :interface="interfaceSearch"
            />
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import OrganizationalStructurePage from './OrganizationalStructurePage'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'OrganizationalStructure',
  components: {
    CrudLayoutSearch,
    OrganizationalStructurePage
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
export default class OrganizationalStructure extends Vue {
  levelList = [];
  level = null;
  indice = 0;

  get interfaceSearch () {
    if (this.level.level == 1) {
      return 'organizationalStructure.pesquisarFirstLevel'
    }
    return 'organizationalStructure.pesquisar'
  }

  get page () {
    return OrganizationalStructurePage
  }

  get params () {
    const parentLevel =
      this.levelList.find(element => element.level === this.level.level - 1) ||
      this.level
    return {
      organizationalStructureLevel: this.level.id,
      labelGrid: this.level.name,
      labelGridParent: parentLevel.name
    }
  }

  async beforeMount () {
    const { registros } = await repository.resolveDatatableModel(
      'organizationalStructureLevel.pesquisar'
    )
    this.levelList = registros
    this.level = this.levelList[0]
  }

  changeLevelSelecet (item) {
    this.level = item
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
  #OrganizationalStructure {
    .buttons-top-crud{
      margin-top: 5px;
      margin-bottom: -3px;
   }

    ::v-deep {
      .jt-crud-container {
        padding: 0%;
      }
    }

    .padding-crud{
      padding: 0px 10px 10px;
      margin-top: -15px;
    }

    .itemSelect{
      color: white;
      background: $secondary!important;
      border-left: 5px solid $dark!important;
      padding-left: 5%!imporant;
    }

    .item{
      background: white;
      font-weight: 500;
      padding-left: 10%;
      font-size: 1rem;
    }
  }
</style>
